const SelectGrayIcon: React.FC = () => {
  return (
    <svg width="8" height="6" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.94 0.529999L4 3.58333L7.06 0.529999L8 1.47L4 5.47L0 1.47L0.94 0.529999Z" fill="#666666" />
    </svg>
  );
};
export default SelectGrayIcon;
